import {Event} from "@pency/api/analytics/types";

import analytics from "./instance";

export default {
  track: (event: Event) => analytics.track(event),
  pageview: (path: string) => analytics.pageview(path),
};
